import React, { useState } from 'react';
import { Drawer, Empty } from 'antd';
import Room from './Room';
import MessageBox from './MessageBox';
import { ChatModalProps, Message } from '../interfaces/interfaces';
import { useChat } from '../contexts/ChatContext';
import style from "../styles/chat.module.sass"


export function ChatModal(props: ChatModalProps) {
    const { open, close, unreadList } = props;
    const { roomSocket, rooms, theme, loadingOpenRoom } = useChat();

    const [messages, setMessages] = useState<Message[]>([]);

    const [activeBox, setActiveBox] = useState<boolean>(false);
    const [activeRoom, setActiveRoom] = useState<string | null>(null);
    const [activeRoomIndex, setActiveRoomIndex] = useState<number>(0);
    const [userTyping, setUserTyping] = useState<string | null>(null);

    const handleClose = () => {
        if (roomSocket) {
            roomSocket.close();
        }
        setActiveRoom(null);
        setMessages([]);
        setActiveRoomIndex(0)
        close();
    }

    // console.log('rooms', rooms)

    return (
        <div className={style.curiobites_chat_modal}>
            <Drawer
                title={"Chat"}
                rootStyle={{
                    boxShadow: 'none'
                }}
                className={style.chat_modal + ` curiobites-chat curiobites-chat-${theme}`}
                classNames={{ body: style.modal_body }}
                open={open}
                onClose={handleClose}
                width={900}
            >
                <div className={style.chat_box}>
                    <div className={style.room_list}>

                        {rooms.map((item: any, index: number) => (
                            <Room
                                index={index}
                                key={item.id}
                                room={item}
                                unreadList={unreadList}
                                setMessages={setMessages}
                                setActiveBox={setActiveBox}
                                setActiveRoom={setActiveRoom}
                                activeRoom={activeRoom}
                                setUserTyping={setUserTyping}
                                setActiveRoomIndex={setActiveRoomIndex}
                            />
                        ))}

                        {
                            activeRoomIndex > 0 &&
                            <div className={`${style.active_room_slider} active_room_slider`}
                                style={{ transform: `translateY(${(activeRoomIndex - 1) * 55 + 8}px)` }}
                            ></div>
                        }

                        {rooms.length === 0 &&
                            <Empty className={style.empty} />
                        }
                    </div>


                    <div className={loadingOpenRoom ? `${style.message_form} ${style._is_loading}` : style.message_form}>

                        {loadingOpenRoom &&
                            <div className={style.loading_bar}></div>
                        }
                        {!activeRoom && !loadingOpenRoom &&
                            < div className={style.empty_state}>
                                <img src="https://curiobites-media.s3.ap-southeast-1.amazonaws.com/messaging.png" alt="" />
                                <h3>Select from the chatlist to start sending messages.</h3>
                            </div>
                        }

                        {activeRoom &&
                            <MessageBox
                                activeRoom={activeRoom}
                                messages={messages}
                                setMessages={setMessages}
                                activeBox={activeBox}
                                userTyping={userTyping}
                                setUserTyping={setUserTyping}
                                socket={roomSocket}
                            />
                        }
                    </div>
                </div>
            </Drawer >
        </div >
    );
}
